/**
 * Get full image URL
 */
export const getFullImageUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  // Static files are served from the server root, not the /api prefix
  const baseUrl = (process.env.REACT_APP_BASEAPI_URL || "").replace(/\/api\/?$/, "");
  return `${baseUrl}/${path}`;
};

/**
 * Debounce function
 */
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};
